import _regeneratorRuntime from 'babel-runtime/regenerator';
import _extends from 'babel-runtime/helpers/extends';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';
import SelectorFormItem from '../components/selector-form-item.vue';
import LanguageSelector from '@/components/LanguageSelector/index.vue';
import { getCreationSizeList as _getCreationSizeList } from '@/api/demand/creation';
import generateShortId from '@/utils/generateId.js';
import CheckboxGroupFormItem from './checkbox-group-form-item.vue';

/**
 * 判断是否是特定渠道，选择「其它」渠道时返回 false
 * @param {number|string} channel
 */
var isSpecificChannel = function isSpecificChannel(channel) {
  return Number(channel) !== 99;
};

export default {
  components: {
    SelectorFormItem: SelectorFormItem,
    LanguageSelector: LanguageSelector,
    CheckboxGroupFormItem: CheckboxGroupFormItem
  },

  props: {
    index: {
      type: Number,
      require: true
    },
    demandType: {
      type: [Number, String],
      require: true
    },
    creation: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    formItemList: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    validate: {
      type: Function,
      default: function _default() {}
    },
    list: {
      type: Array,
      required: true
    },
    updateCreationList: {
      type: Function,
      default: function _default() {}
    }
  },

  data: function data() {
    var validateSize = function validateSize(rule, value, callback) {
      if (value && value.trim() && !/^[0-9]+\x[0-9]+$/g.test(value)) {
        return callback(new Error('格式错误，正确格式为：数字x数字，请修改后重试。'));
      }
      return callback();
    };
    return {
      formConfig: {
        inline: true,
        labelPosition: 'top',
        labelWidth: ''
      },
      creationSizeList: [],
      checkAllSizeValue: false,
      indeterminate: false,
      moreSize: {
        rules: [{
          validator: validateSize,
          trigger: 'blur'
        }]
      }
    };
  },


  watch: {
    // 监听 formItemList，当某个表单项被隐藏时，就将其值重置为空，除了通用的，其它逻辑不要在这里监听
    formItemList: {
      handler: function handler(newFormItemList) {
        var _this = this;

        _.each(newFormItemList, function (formItem, key) {
          if (formItem.visible === false) {
            if (_.isArray(_this.creation[key])) {
              // eslint-disable-next-line vue/no-mutating-props
              _this.creation[key] = [];
            } else {
              // eslint-disable-next-line vue/no-mutating-props
              _this.creation[key] = '';
            }
          }
        });
      },

      deep: true
    },

    // 根据渠道修改被删除控件的值
    // 选择具体内容：“创意尺寸”可选特定渠道支持的尺寸，多选，常用尺寸置顶，且默认勾选
    // 当“投放渠道”为“其他”：”创意尺寸“为文本框，可输入文本，文本最大限制为100
    'creation.channel': function creationChannel(val) {
      if (this.demandType === 2 && isSpecificChannel(val) && this.creation.type) {
        this.getCreationSizeList({
          channel_id: this.creation.channel,
          type: this.creation.type
        });
      } else {
        this.creationSizeList = [];
      }
      // eslint-disable-next-line vue/no-mutating-props
      this.creation.sizes = [];
      // eslint-disable-next-line vue/no-mutating-props
      this.creation.size = '';
    },
    'creation.type': function creationType(val) {
      if (this.demandType === 2 && isSpecificChannel(this.creation.channel) && val) {
        this.getCreationSizeList({
          channel_id: this.creation.channel,
          type: this.creation.type
        });
      } else {
        this.creationSizeList = [];
      }
      // eslint-disable-next-line vue/no-mutating-props
      this.creation.sizes = [];
      // eslint-disable-next-line vue/no-mutating-props
      this.creation.size = '';
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.form = this.$refs.form;
    this.$root.$once('demand:get-creation-size', function () {
      if (isSpecificChannel(_this2.creation.channel) && _this2.demandType === 2) {
        _this2.getCreationSizeList({
          channel_id: _this2.creation.channel,
          type: _this2.creation.type
        });
      }
    });
  },
  destroyed: function destroyed() {
    this.$root.$off('demand:get-creation-size');
  },


  methods: {
    /**
     * @param {{channel_id: string|array, type: string|number}} params
     */
    getCreationSizeList: function getCreationSizeList(params) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var postParams, res, list, newCreationList;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                postParams = _.cloneDeep(params);

                if (_.isArray(postParams.channel_id)) {
                  postParams.channel_id = postParams.channel_id.join();
                }
                _context.next = 5;
                return _getCreationSizeList(postParams);

              case 5:
                res = _context.sent;
                list = _.get(res, 'data.data.list') || [];


                _this3.creationSizeList = list.map(function (item) {
                  return {
                    _id: generateShortId(),
                    value: item.name,
                    label: item.name,
                    border: true
                  };
                });

                // 如果存在sizes的值，另外更新creationSizeList，以保证所有自定义的尺寸也可以显示在视图
                if (_this3.creation.sizes && _this3.creation.sizes.length) {
                  _this3.creation.sizes.forEach(function (item) {
                    if (_this3.creationSizeList.findIndex(function (e) {
                      return e.value === item;
                    }) === -1) {
                      _this3.creationSizeList.push({
                        _id: generateShortId(),
                        value: item,
                        label: item,
                        border: true
                      });
                    }
                  });
                }

                // 更新 creation list
                newCreationList = _.cloneDeep(_this3.list).map(function (item, index) {
                  if (item.sizes.length === 0 && index === _this3.index) {
                    return _extends({}, item, {
                      sizes: list.filter(function (item) {
                        return item.default_checked === 1;
                      }).map(function (item) {
                        return item.name;
                      })
                    });
                  }
                  return item;
                });

                // 异步更新数据

                _this3.$nextTick(function () {
                  _this3.updateCreationList(newCreationList);
                  _this3.$nextTick(function () {
                    _this3.handleCheckSize(_this3.list[_this3.index].sizes);
                  });
                });
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](0);

                _this3.creationSizeList = [];

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[0, 13]]);
      }))();
    },

    // 选择尺寸
    handleCheckAllSize: function handleCheckAllSize(value) {
      var _this4 = this;

      this.indeterminate = false;
      var newCreationList = _.cloneDeep(this.list).map(function (item, index) {
        if (index === _this4.index) {
          return _extends({}, item, {
            sizes: value ? _.cloneDeep(_this4.creationSizeList).map(function (item) {
              return item.label;
            }) : []
          });
        }
        return item;
      });

      // 异步更新数据
      this.$nextTick(function () {
        _this4.updateCreationList(newCreationList);
      });
    },
    handleCheckSize: function handleCheckSize(value) {
      this.checkAllSizeValue = value.length === this.creationSizeList.length;
      this.indeterminate = value.length > 0 && value.length < this.creationSizeList.length;
    },
    hanldeSaveSize: function hanldeSaveSize() {
      var _this5 = this;

      this.$refs.form.validateField('more_size', function (valid) {
        if (!valid) {
          _this5.addNewSize();
        }
      });
    },
    addNewSize: function addNewSize() {
      var _this6 = this;

      if (!this.creation.more_size) return;
      if (this.creationSizeList.findIndex(function (e) {
        return e.value === _this6.creation.more_size;
      }) === -1) {
        this.creationSizeList.push({
          _id: generateShortId(),
          value: this.creation.more_size,
          label: this.creation.more_size,
          border: true
        });
      }
      this.$nextTick(function () {
        // eslint-disable-next-line vue/no-mutating-props
        _this6.creation.more_size = '';
        _this6.handleCheckSize(_this6.list[_this6.index].sizes);
      });
    }
  }
};